import { FC } from "react";
import { Line } from "@ant-design/plots";

const LineChart: FC<any> = (props) => {
  const data = props?.data ? props.data : [];

  const config = {
    data,
    xField: "year_month",
    yField: "cost",
    smooth:true,
    meta: {
      cost:{
        formatter:(val:any)=> `$ ${Math.round(val)?.toLocaleString()}`
      }
    },
    tooltip: {
      domStyles:{
        "g2-tooltip": {backgroundColor:"#091e42", color:"#fff", borderRadius:"8px"}
      }
  },
  
  };
  
  return <Line {...config} />;
};

export default LineChart;
